import dayjs from "dayjs";

export function parseFormDataTextToJsonString(text) {
    if (!text.includes("form-data")) {
        return JSON.stringify(text);
    } else {
        let formDataStr = text.split("form-data; name=");
        let objectArray = [];
        formDataStr.forEach(subString => {
            const data = subString.substring(subString.indexOf("\\"), subString.indexOf('--'))
                .replaceAll("\r\n\r\n", ":")
                .replaceAll("\r\n", "");
            objectArray.push(data)
        })
        return objectArray.join(' ');
    }
}

export const formatdate = (timestamp) => {
    let d = timestamp ? dayjs(timestamp * 1000).utcOffset(180).format('YYYY-MM-DD HH:mm:ss') : null
    return d;
}


export const domainAlias = window._gamesConfig.reduce((result, game) => {
    result[game.hostname] = game.code;
    return result;
}, {});

export const domain_constants = window._gamesConfig.reduce((result, game) => {
    result[game.code] = {
        'DEVELOP_ENV': game.environments.develop,
        'LIVEOPS_ENV': game.environments.liveops,
        'PROD': game.environments.prod,
        'ROLE_SUFFIX': game.roleSuffix
    };
    return result;
}, {});

export const configs = window._gamesConfig.reduce((result, game) => {
    const config = {
        baseUrl: game.baseUrl,
        prodUrl: game.prodUrl,
        abTestUrl: game.abTestUrl,
        abTestProdUrl: game.abTestProdUrl,
        title: game.title,
    };

    if (game.calendarUrl) config.calendarUrl = game.calendarUrl;
    if (game.calendarGameUrl) config.calendarGameUrl = game.calendarGameUrl;
    if (game.timelineMode !== undefined) config.timelineMode = game.timelineMode;

    config.msal = {
        auth: {
            authority: game.msalConfig.authority,
            clientId: game.msalConfig.clientId,
            redirectUri: document.location.host === 'localhost:3000'
                ? 'http://localhost:3000/'
                : `https://${game.hostname}/`
        },
        cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: game.msalConfig.storeAuthStateInCookie
        }
    };

    if (game.msalConfig.tokenRenewalOffsetSeconds) {
        config.msal.system = {
            tokenRenewalOffsetSeconds: game.msalConfig.tokenRenewalOffsetSeconds
        };
    }

    result[game.code] = config;
    return result;
}, {});

export function getDomainAlias() {
    let h = window.location.hostname;
    if (!domainAlias.hasOwnProperty(h)) {
        return 'local';
    }
    return domainAlias[h];
}
